import React from "react";
import {
    makeStyles,
    withStyles,
    Grid,
    Dialog,
    IconButton,
    Button,
    Paper,
    AppBar,
    Toolbar,
    Slide,
    Container,
    Tabs,
    Tab,
} from '@material-ui/core';
import {MuiThemeProvider, responsiveFontSizes} from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import UserProfile from './components/UserProfile'
import EntitlementRecord from './components/EntitlementRecord';
import LeaveRecord from './components/LeaveRecord'
import customAxios from "../../../API/customAxios";
import { mobileTheme, globalDialogStyle, adminDialogStyle, getMuiTheme } from "../../../UIComponent/CommonStyle"
import { getColumnsForBalanceRecord, getBalanceRecordOptions, getColumnsForCompLeaveReqRecord, getCompLeaveReqRecordOptions } from "../../../MyCompLeaveReqs/component/TableSetting";
import CompLeaveReqsCollection from "../../../Function/CompLeaveReqs";
import { useIntl } from 'react-intl';
import MUIDataTable from 'mui-datatables';
import moment from 'moment';
import Edit from "../../../MyCompLeaveReqs/component/Edit";
import TabPanel, { a11yProps } from '../../../UIComponent/TabPanel';
import Details from "../../../MyLeave/component/Details";
import { styled } from '@mui/material/styles';

const thisTheme = responsiveFontSizes(mobileTheme);

const useStyles = makeStyles((theme) => ({
    ...globalDialogStyle(theme),
    ...adminDialogStyle(theme),
    content: {
        fontSize: 12,
    },
    root: {
        padding: theme.spacing(2),
        backgroundColor: '#f0f2f5',
        overflow: 'visible',
    },
    container: {
        width: '100%',
        maxWidth: '100%',
    },
    tabPanel: {
        marginBottom: 1,
    },
    tabs: {
        fontWeight: 600,
    },
    mainPaper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'visible',
        flexDirection: 'column',
        height: '100%',
    },
}));

const StyledDataTable = styled(MUIDataTable)({
    '& [class*="MuiToolbar-root"] ~ div': {
        overflow: 'visible',
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Index({handleClose, open, showId, updateNewAllowanceRecord, backToTable}) {
    const classes = useStyles();
    const intl = useIntl();
    const page = 'Employee Record';
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [allowanceRecord, setAllowanceRecord] = React.useState({});
    const [requestData, setRequestData] = React.useState([]);
    const [balanceData, setBalanceData] = React.useState([]);
    const [openDetailPage, setOpenDetailPage] = React.useState(false);
    const [compLeaveReqId, setCompLeaveReqId] = React.useState();
    const isOfficeHourDuty = allowanceRecord.staff_duty === window.global.officeHours;
    const [tabValue, setTabValue] = React.useState(0);
    const [openProgress, setOpenProgress] = React.useState(false);
    const [updatedIds, setUpdatedIds] = React.useState([]);

    const tab1Label = intl.formatMessage({ id: 'comp_leave.request_view' });
    const tab2Label = intl.formatMessage({ id: 'comp_leave.balance_view' });

    React.useEffect(() => {
        customAxios.get(`/get_employee_allowance/` + showId)
            .then(res => {
                const allowance = res.data;
                setAllowanceRecord(allowance);
                setRequestData(
                    CompLeaveReqsCollection(
                        allowance.comp_leave_requests,
                        intl,
                        'CompLeaveReqs'
                    )
                );
                setBalanceData(
                    CompLeaveReqsCollection(
                        allowance.comp_leave_balance,
                        intl,
                        'Balance'
                    )
                );
                setShowCompetent(true);
            })
    }, []);

    const [openTable, setOpenTable] = React.useState(false);
    const [buttonText, showButtonText] = React.useState('Show Leave Record');

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const showTable = () => {
        if (openTable === true) {
            setOpenTable(false);
            showButtonText('Show Leave Record');
        } else {
            setOpenTable(true);
            showButtonText('Show User Profile');
        }
    };

    const updateAllowanceRecord = (values) => {
        setAllowanceRecord(values);
        updateNewAllowanceRecord(values);
    };

    const handleDateSubmit = (id, value) => {
        customAxios.put(`/extend_expiry_date/${id}`, { expiryDate: value })
            .then(response => {
                setUpdatedIds([...updatedIds, response.data.id]);
            })
            .catch(error => {
                console.error(error);
            });
    };
    
    const handleInputChange = (id, field, value) => {
        if (field === 'expiryDate') {
            handleDateSubmit(id, value);
        }
    };

    const handleOpenProgress = (id) => {
        setCompLeaveReqId(id);
        setOpenProgress(true);
    };
    const handleCloseProgress = () => {
        setOpenProgress(false);
    };

    const handleOpenDetailPage = (id) => {
        setCompLeaveReqId(id);
        setOpenDetailPage(true);
    };
    const handleCloseDetailPage = () => {
        setOpenDetailPage(false);
    };

    const requestViewColumns = getColumnsForCompLeaveReqRecord(
        handleOpenProgress,
        handleOpenDetailPage,
        intl
    );
    const requestViewOptions = getCompLeaveReqRecordOptions(intl);

    const balanceViewColumns = getColumnsForBalanceRecord(
        balanceData, 
        intl, 
        page, 
        handleInputChange,
        updatedIds,
        allowanceRecord.staff_duty
    ); 
    const balanceViewOptions = getBalanceRecordOptions(intl, page, allowanceRecord.staff_duty); 

    return (
        <MuiThemeProvider theme={thisTheme}>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}
                    PaperProps={{
                        style: {
                            backgroundColor: '#f0f2f5',
                            boxShadow: 'none',
                        },
                    }}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div className={classes.root}>
                    <div className={classes.showButtonDiv}>
                        <Button
                            variant="contained"
                            size="small"
                            color="primary"
                            className={classes.showButton}
                            onClick={showTable}>
                            {buttonText}
                        </Button>
                    </div>
                    <React.Fragment>
                        {openTable ?
                            <LeaveRecord
                                userId={showId}
                                employeeName={allowanceRecord.employee_name}
                            />
                            :
                            <Grid container spacing={3}>
                                <Grid item md={6} xs={12}>
                                    <Paper className={classes.mainPaper}>
                                        {showCompetent ?
                                            <UserProfile
                                                employeeName={allowanceRecord.employee_name}
                                                managerName={allowanceRecord.manager_name}
                                                staffNo={allowanceRecord.staff_no}
                                                position={allowanceRecord.position}
                                                mail={allowanceRecord.mail}
                                                staffDuty={allowanceRecord.staff_duty}
                                                entryDate={allowanceRecord.entry_date}
                                                active={allowanceRecord.active_label}
                                                location={allowanceRecord.location.name}
                                                department={allowanceRecord.department.name}
                                            />
                                            :
                                            <div className={classes.circularProgress}>
                                                <CircularProgress/>
                                            </div>
                                        }
                                    </Paper>
                                </Grid>
                                
                                <Grid item md={6} xs={12}>
                                    <Paper className={classes.mainPaper}>
                                        {showCompetent ?
                                            <EntitlementRecord
                                                showId={showId}
                                                employeeName={allowanceRecord.employee_name}
                                                allowanceRecord={allowanceRecord}
                                                updateAllowanceRecord={updateAllowanceRecord}
                                                backToTable={backToTable}
                                            />
                                            :
                                            <div className={classes.circularProgress}>
                                                <CircularProgress/>
                                            </div>
                                        }
                                    </Paper>
                                </Grid>

                                <Grid item xs={12}>
                                    <main className={classes.content}>
                                        <Paper className={classes.mainPaper}>
                                            <AppBar position='static' color='default' className={classes.tabPanel}>
                                                <Tabs
                                                    value={tabValue}
                                                    onChange={handleTabChange}
                                                    indicatorColor='primary'
                                                    textColor='primary'
                                                    variant='scrollable'
                                                    scrollButtons='auto'
                                                    style={{minWidth: '100%'}}
                                                >
                                                    <Tab label={tab1Label} {...a11yProps(0)} className={classes.tabs} />
                                                    <Tab label={tab2Label} {...a11yProps(1)} className={classes.tabs} />
                                                </Tabs>
                                            </AppBar>

                                            {/* Request View */}
                                            <TabPanel value={tabValue} index={0} disableGutters={true}>
                                                <MuiThemeProvider theme={getMuiTheme()}>
                                                    <MUIDataTable
                                                        title={intl.formatMessage({ id: 'comp_leave.request_record' })}
                                                        data={requestData}
                                                        columns={requestViewColumns}
                                                        options={requestViewOptions}
                                                    />
                                                </MuiThemeProvider>
                                            </TabPanel>

                                            {/* Balance View */}
                                            <TabPanel value={tabValue} index={1} disableGutters={true}>
                                                <MuiThemeProvider theme={getMuiTheme()}>
                                                    <StyledDataTable
                                                        title={intl.formatMessage({ id: 'comp_leave.endorsed_balance' })}
                                                        data={balanceData}
                                                        columns={balanceViewColumns}
                                                        options={balanceViewOptions}
                                                    />
                                                </MuiThemeProvider>
                                            </TabPanel>
                                        </Paper>
                                    </main>
                                </Grid>
                                {openProgress && (
                                    <Details
                                        handleClose={handleCloseProgress}
                                        open={openProgress}
                                        showId={compLeaveReqId}
                                        page={'Comp Leave Reqs'}
                                    ></Details>
                                )}
                                {openDetailPage && (
                                    <Edit
                                        handleClose={handleCloseDetailPage}
                                        open={openDetailPage}
                                        showId={compLeaveReqId}
                                        actionPage='Employee Record'
                                    ></Edit>
                                )}
                            </Grid>
                        }
                    </React.Fragment>
                </div>
            </Dialog>
        </MuiThemeProvider>
    );
}